/**
 * Email que el visitante escribió en el conector light, guardado solo en su
 * navegador para prerrellenar el registro cuando quiera pedir información.
 */
const KEY = "bizaclia:conector-light-email";

export function guardarEmailConectorLight(email: string) {
  try {
    localStorage.setItem(KEY, email);
  } catch {
    // almacenamiento no disponible: el registro se rellena a mano
  }
}

export function leerEmailConectorLight(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}
